<template>
  <v-container class="mt-4 ml-2 pr-6" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title class="text-subtitle-1">
            Conversaciones IA
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              small
              tile
              class="mr-2"
              :loading="cargando"
              @click="cargarListado"
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" md="3">
                <v-select
                  v-model="tipoCurso"
                  :items="tiposCurso"
                  label="Tipo de curso"
                  filled
                  dense
                  hide-details
                  @change="cargarListado"
                />
              </v-col>

              <v-col cols="12" md="5">
                <v-file-input
                  v-model="archivo"
                  label="Subir JSON (master.json)"
                  accept=".json,application/json"
                  filled
                  dense
                  hide-details
                  prepend-icon="mdi-code-json"
                  show-size
                />
              </v-col>

              <v-col cols="12" md="4" class="d-flex align-center">
                <v-btn
                  color="green"
                  dark
                  small
                  tile
                  class="mr-2"
                  :loading="subiendo"
                  :disabled="!archivo"
                  @click="subirJson"
                >
                  <v-icon left small>mdi-upload</v-icon>
                  Subir JSON
                </v-btn>
                <v-btn
                  color="orange"
                  dark
                  small
                  tile
                  :loading="generandoTodo"
                  :disabled="!pendientesCount"
                  @click="generarTodo"
                >
                  <v-icon left small>mdi-robot</v-icon>
                  Generar pendientes ({{ pendientesCount }})
                </v-btn>
              </v-col>
            </v-row>

            <v-row class="mt-2">
              <v-col cols="12" md="8">
                <v-textarea
                  v-model="promptTexto"
                  label="Prompt de generación"
                  filled
                  dense
                  rows="4"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="4" class="d-flex align-center">
                <v-btn color="primary" small tile :loading="guardandoPrompt" @click="guardarPrompt">
                  Guardar prompt
                </v-btn>
                <v-btn class="ml-2" text small @click="cargarPrompt">Recargar</v-btn>
              </v-col>
            </v-row>

            <v-row class="mt-3">
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="search"
                  label="Buscar"
                  filled
                  dense
                  hide-details
                  append-icon="mdi-magnify"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  v-model="filtroEstado"
                  :items="estadosFiltro"
                  label="Estado"
                  filled
                  dense
                  hide-details
                  clearable
                />
              </v-col>
            </v-row>

            <v-data-table
              class="mt-4 elevation-0"
              dense
              :headers="headers"
              :items="itemsFiltrados"
              :search="search"
              :loading="cargando"
              item-key="key"
            >
              <template v-slot:item.estado="{ item }">
                <v-chip small :color="colorEstado(item.estado)" dark>
                  {{ labelEstado(item.estado) }}
                </v-chip>
              </template>

              <template v-slot:item.acciones="{ item }">
                <v-btn
                  x-small
                  tile
                  color="primary"
                  class="mr-1"
                  :loading="item._loading"
                  @click="generarLeccion(item)"
                >
                  Generar
                </v-btn>
                <v-btn
                  x-small
                  tile
                  color="indigo"
                  class="mr-1"
                  dark
                  @click="abrirDetalle(item)"
                >
                  Ver
                </v-btn>
                <v-btn
                  x-small
                  tile
                  outlined
                  color="orange"
                  @click="generarNivel(item.nivel)"
                >
                  Regen. nivel {{ item.nivel }}
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Detalle lección -->
    <v-dialog v-model="dialogDetalle" max-width="1000" persistent scrollable>
      <v-card v-if="detalle">
        <v-card-title>
          Nivel {{ detalleItem && detalleItem.nivel }} · Lección {{ detalleItem && detalleItem.leccion }}
          <v-spacer />
          <v-btn icon @click="dialogDetalle = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-subtitle v-if="detalle.fuente">
          {{ detalle.fuente.titulo_nivel }} — {{ detalle.fuente.titulo_leccion }}
        </v-card-subtitle>
        <v-card-text>
          <div v-for="num in [1, 2, 3]" :key="num" class="mb-6">
            <div class="d-flex align-center mb-2">
              <h3 class="text-subtitle-1 mb-0">Conversación {{ num }}</h3>
              <v-spacer />
              <v-btn
                x-small
                tile
                color="orange"
                dark
                class="mr-2"
                :loading="regenerandoNum === num"
                @click="regenerarConversacion(num)"
              >
                Regenerar esta
              </v-btn>
            </div>

            <div v-if="ultimaDeNumero(num)">
              <v-chip small class="mb-2" :color="colorEstado(ultimaDeNumero(num).estado)" dark>
                {{ ultimaDeNumero(num).estado }} · v{{ ultimaDeNumero(num).version }}
                <span v-if="ultimaDeNumero(num).tema"> · {{ ultimaDeNumero(num).tema }}</span>
              </v-chip>
              <v-simple-table dense>
                <tbody>
                  <tr
                    v-for="(t, i) in intercambiosDe(ultimaDeNumero(num))"
                    :key="i"
                  >
                    <td width="90">
                      <b>{{ t.rol }}</b>
                    </td>
                    <td>{{ t.texto }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div>
            <v-alert v-else dense type="info" outlined>Sin conversación generada</v-alert>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            text
            :disabled="!hayGeneradas"
            @click="rechazarGeneradas"
          >
            Rechazar
          </v-btn>
          <v-spacer />
          <v-btn
            color="orange"
            dark
            tile
            small
            :loading="regenerandoLeccion"
            @click="generarLeccion(detalleItem, true)"
          >
            Regenerar lección
          </v-btn>
          <v-btn
            color="green"
            dark
            tile
            small
            :loading="aprobando"
            :disabled="!hayGeneradas"
            @click="aprobarLeccion"
          >
            Aprobar las 3
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargar" />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Alerta from '@/components/alertas/Alerta.vue'
import carga from '@/components/alertas/carga.vue'
import validarErrores from '@/mixins/validarErrores'

export default {
  name: 'ConversacionesIA',
  components: { Alerta, carga },
  mixins: [validarErrores],
  data: () => ({
    tipoCurso: 'adultos',
    tiposCurso: [
      { text: 'Adultos', value: 'adultos' },
      { text: 'Teens', value: 'teens' },
    ],
    archivo: null,
    items: [],
    search: '',
    filtroEstado: null,
    estadosFiltro: [
      { text: 'Sin generar', value: 'sin_generar' },
      { text: 'Desactualizada', value: 'desactualizada' },
      { text: 'Generada', value: 'generada' },
      { text: 'Aprobada', value: 'aprobada' },
    ],
    headers: [
      { text: 'Nivel', value: 'nivel', width: 80 },
      { text: 'Lección', value: 'leccion', width: 90 },
      { text: 'Título nivel', value: 'titulo_nivel' },
      { text: 'Título lección', value: 'titulo_leccion' },
      { text: 'Estado', value: 'estado', width: 140 },
      { text: 'Acciones', value: 'acciones', sortable: false, width: 320 },
    ],
    cargando: false,
    subiendo: false,
    generandoTodo: false,
    promptTexto: '',
    guardandoPrompt: false,
    dialogDetalle: false,
    detalle: null,
    detalleItem: null,
    aprobando: false,
    regenerandoNum: null,
    regenerandoLeccion: false,
    cargar: false,
    respuestaAlerta: false,
    parametros: { dialogError: false, mensaje: '', color: '' },
  }),
  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),
    pendientesCount() {
      return this.items.filter((i) => i.pendiente).length
    },
    itemsFiltrados() {
      if (!this.filtroEstado) return this.items
      return this.items.filter((i) => i.estado === this.filtroEstado)
    },
    hayGeneradas() {
      if (!this.detalle || !this.detalle.conversaciones) return false
      return [1, 2, 3].some((n) => {
        const u = this.ultimaDeNumero(n)
        return u && u.estado === 'generada'
      })
    },
  },
  async created() {
    await this.cargarPrompt()
    await this.cargarListado()
  },
  methods: {
    colorEstado(estado) {
      const map = {
        sin_generar: 'grey',
        desactualizada: 'orange',
        generada: 'blue',
        aprobada: 'green',
        rechazada: 'red',
        reemplazada: 'grey darken-1',
      }
      return map[estado] || 'grey'
    },
    labelEstado(estado) {
      const map = {
        sin_generar: 'Sin generar',
        desactualizada: 'Desactualizada',
        generada: 'Generada',
        aprobada: 'Aprobada',
        rechazada: 'Rechazada',
        reemplazada: 'Reemplazada',
      }
      return map[estado] || estado
    },
    async cargarListado() {
      this.cargando = true
      try {
        const { data } = await this.$http.get('admin.ia.listado', {
          params: { tipo_curso: this.tipoCurso },
        })
        this.items = (data.items || []).map((i) => ({
          ...i,
          key: `${i.tipo_curso}-${i.nivel}-${i.leccion}`,
          _loading: false,
        }))
      } catch (e) {
        this.validarError(e)
      } finally {
        this.cargando = false
      }
    },
    async cargarPrompt() {
      try {
        const { data } = await this.$http.get('admin.ia.prompt')
        this.promptTexto = (data.prompt && data.prompt.prompt_texto) || ''
      } catch (e) {
        this.validarError(e)
      }
    },
    async guardarPrompt() {
      this.guardandoPrompt = true
      try {
        await this.$http.post('admin.ia.prompt', {
          prompt_texto: this.promptTexto,
          iderp: this.getdatosUsuarioERPERP.iderp,
        })
        this.validarSuccess('Prompt guardado')
      } catch (e) {
        this.validarError(e)
      } finally {
        this.guardandoPrompt = false
      }
    },
    async subirJson() {
      if (!this.archivo) return
      this.subiendo = true
      this.cargar = true
      try {
        const fd = new FormData()
        fd.append('archivo', this.archivo)
        fd.append('tipo_curso', this.tipoCurso)
        const { data } = await this.$http.post('admin.ia.upload', fd)
        this.validarSuccess(
          `Procesado: ${data.nuevas} nuevas, ${data.actualizadas} actualizadas, ${data.sin_cambio} sin cambio`
        )
        this.archivo = null
        await this.cargarListado()
      } catch (e) {
        this.validarError(e)
      } finally {
        this.subiendo = false
        this.cargar = false
      }
    },
    async generarLeccion(item, desdeDetalle = false) {
      if (!item) return
      if (desdeDetalle) this.regenerandoLeccion = true
      else this.$set(item, '_loading', true)
      this.cargar = true
      try {
        await this.$http.post('admin.ia.generar', {
          tipo_curso: this.tipoCurso,
          nivel: item.nivel,
          leccion: item.leccion,
        })
        this.validarSuccess('Conversaciones generadas')
        await this.cargarListado()
        if (desdeDetalle || this.dialogDetalle) {
          await this.abrirDetalle(item)
        }
      } catch (e) {
        this.validarError(e)
      } finally {
        if (desdeDetalle) this.regenerandoLeccion = false
        else this.$set(item, '_loading', false)
        this.cargar = false
      }
    },
    async generarNivel(nivel) {
      this.cargar = true
      try {
        const { data } = await this.$http.post('admin.ia.generar.nivel', {
          tipo_curso: this.tipoCurso,
          nivel,
        })
        this.validarSuccess(`Nivel ${nivel}: ${data.generadas} lecciones generadas`)
        await this.cargarListado()
      } catch (e) {
        this.validarError(e)
      } finally {
        this.cargar = false
      }
    },
    async generarTodo() {
      this.generandoTodo = true
      this.cargar = true
      try {
        const { data } = await this.$http.post('admin.ia.generar.todo', {
          tipo_curso: this.tipoCurso,
        })
        this.validarSuccess(
          `Pendientes: ${data.total_pendientes}, generadas: ${data.generadas}`
        )
        await this.cargarListado()
      } catch (e) {
        this.validarError(e)
      } finally {
        this.generandoTodo = false
        this.cargar = false
      }
    },
    async abrirDetalle(item) {
      this.detalleItem = item
      this.cargar = true
      try {
        const { data } = await this.$http.get(
          `admin.ia.conversaciones/${this.tipoCurso}/${item.nivel}/${item.leccion}`
        )
        this.detalle = data
        this.dialogDetalle = true
      } catch (e) {
        this.validarError(e)
      } finally {
        this.cargar = false
      }
    },
    ultimaDeNumero(num) {
      if (!this.detalle || !this.detalle.conversaciones) return null
      const lista = this.detalle.conversaciones[num] || this.detalle.conversaciones[String(num)] || []
      if (!lista.length) return null
      return lista[0]
    },
    intercambiosDe(conv) {
      if (!conv || !conv.guion_json) return []
      const g = conv.guion_json
      return g.intercambios || g.exchanges || []
    },
    async regenerarConversacion(num) {
      if (!this.detalleItem) return
      this.regenerandoNum = num
      this.cargar = true
      try {
        await this.$http.post('admin.ia.generar', {
          tipo_curso: this.tipoCurso,
          nivel: this.detalleItem.nivel,
          leccion: this.detalleItem.leccion,
          numero_conversacion: num,
        })
        this.validarSuccess(`Conversación ${num} regenerada`)
        await this.abrirDetalle(this.detalleItem)
        await this.cargarListado()
      } catch (e) {
        this.validarError(e)
      } finally {
        this.regenerandoNum = null
        this.cargar = false
      }
    },
    async aprobarLeccion() {
      if (!this.detalleItem) return
      this.aprobando = true
      try {
        await this.$http.post('admin.ia.aprobar.leccion', {
          tipo_curso: this.tipoCurso,
          nivel: this.detalleItem.nivel,
          leccion: this.detalleItem.leccion,
          iderp: this.getdatosUsuarioERPERP.iderp,
        })
        this.validarSuccess('Lección aprobada')
        await this.abrirDetalle(this.detalleItem)
        await this.cargarListado()
      } catch (e) {
        this.validarError(e)
      } finally {
        this.aprobando = false
      }
    },
    async rechazarGeneradas() {
      const u = this.ultimaDeNumero(1)
      if (!u) return
      try {
        await this.$http.post(`admin.ia.conversaciones/${u.id}/rechazar`)
        this.validarSuccess('Conversaciones rechazadas')
        await this.abrirDetalle(this.detalleItem)
        await this.cargarListado()
      } catch (e) {
        this.validarError(e)
      }
    },
  },
}
</script>
